// extracted by mini-css-extract-plugin
module.exports = {"Board":"Board_Board__2EIJj","Row":"Board_Row__1_t8U","Cell":"Board_Cell__3zbsA","heartbeat":"Board_heartbeat__3wfun"};